import auth from "./auth";
import account from "./auth/account";
import accountRecovery from "./auth/accountRecovery";
import advertisers from "./auth/advertisers";
import advertisersestablishment from "./auth/advertisersestablishment";
import apis from "./auth/apis";
import authStatistics from "./auth/authStatistics";
import establishments from "./auth/establishments";
import partners from "./auth/partners";
import userLogin from "./auth/userLogin";
import access from "./core/access";
import accessPointController from "./core/accessPointController";
import accessPointGroup from "./core/accessPointGroup";
import accountCore from "./core/account";
import captiveStyle from "./core/account/captive-style";
import address from "./core/address";
import advertising from "./core/advertising";
import alertproblem from "./core/alertproblem";
import anouncerEstablishment from "./core/anouncerEstablishment";
import answeradvertising from "./core/answeradvertising";
import audit from "./core/audit";
import businessHours from "./core/businessHours";
import clients from "./core/clients";
import comments from "./core/comments";
import connections from "./core/connections";
import connectionsupport from "./core/connectionsupport";
import dataController from "./core/data-controller";
import devices from "./core/devices";
import extraField from "./core/extraField";
import freeconnections from "./core/freeconnections";
import general from "./core/general";
import integrationsreport from "./core/integrationsreport";
import interactions from "./core/interactions";
import ipfirewall from "./core/ipfirewall";
import leads from "./core/leads";
import localPermissions from "./core/localPermissions";
import localPriority from "./core/localPriority";
import localeGroup from "./core/localeGroup";
import localeManagement from "./core/localeManagement";
import locals from "./core/locals";
import loginTypes from "./core/loginTypes";
import macAddresses from "./core/macAddresses";
import partnerCampaign from "./core/partner/campaign/partnerCampaign";
import partnerSystemCommunications from "./core/partner/system-communications/partnerSystemCommunicationsApi";
import promocionalcode from "./core/promocionalcode";
import report from "./core/report";
import statistics from "./core/statistics";
import systemWarning from "./core/systemWarning";
import tag from "./core/tag";
import terms from "./core/terms";
import trackers from "./core/trackers";
import usageTerms from "./core/usageTerms";
import users from "./core/users";
import video from "./core/video";
import voucher from "./core/voucher";
import voucherClientApi from "./core/voucher/client/voucherClientApi";
import voucherSegmentApi from "./core/voucher/segment/voucherSegmentApi";
import externalIntegration from "./integration/externalIntegration";
import externalServiceIntegration from "./integration/externalServiceIntegration";
import integrationManagement from "./integration/integrationManagement";
import establishmentIntegration from "./integration/establishmentIntegration";
import accountPlan from "./marketing/account/accountPlan";
import credit from "./marketing/account/credit";
import automationCampaignTree from "./marketing/automation/campaignTree/index";
import automationFlow from "./marketing/automation/flow/index";
import channel from "./marketing/channel/index";
import channelReport from "./marketing/channel/report";
import emailDns from "./marketing/email/dns/index";
import emailMessage from "./marketing/email/message/index";
import emailSend from "./marketing/email/send/index";
import marketingPlan from "./marketing/plan";
import smsMessage from "./marketing/sms/message/smsMessage";
import configuration from "./marketing/whatsapp/configuration";
import whatsappMessage from "./marketing/whatsapp/message";
import dataWifi from "./core/dataWifi";
import ssid from "./core/ssid";
import beholder from "./beholder";
import accessPointReport from "./core/accessPointReport";
import marketingReport from "./marketing/report/index";

export default {
  install(Vue) {
    Vue.prototype.$api = Vue.api = this;
  },

  apis,

  auth,

  // General
  general,
  address,

  // Admin
  advertisers,
  partners,
  establishments,
  connectionsupport,
  integrationsreport,
  establishmentIntegration,
  systemWarning,
  // Clients
  advertising,
  interactions,
  users,
  leads,
  devices,
  comments,
  connections,
  freeconnections,
  answeradvertising,
  advertisersestablishment,
  integrationManagement,
  externalIntegration,
  externalServiceIntegration,
  promocionalcode,
  alertproblem,
  access,
  tag,
  ipfirewall,
  locals,
  localeGroup,
  accessPointGroup,
  localeManagement,
  macAddresses,
  userLogin,
  localPermissions,
  anouncerEstablishment,
  localPriority,
  audit,
  authStatistics,
  accountRecovery,
  account,
  smsMessage,
  report,
  usageTerms,
  terms,
  voucher,
  video,
  dataController,
  dataWifi,
  beholder,
  core: {
    voucher: {
      segment: voucherSegmentApi,
      client: voucherClientApi,
    },
    clients,
    account: {
      ...accountCore,
      captiveStyle,
    },
    accessPoint: {
      controller: accessPointController,
      report: accessPointReport,
    },
    partner: {
      campaign: partnerCampaign,
      systemCommunications: partnerSystemCommunications,
    },
    businessHours,
    statistics,
    trackers,
    extraField,
    loginTypes,
    ssid,
  },
  marketing: {
    plan: marketingPlan,
    account: {
      credit,
      plan: accountPlan,
    },
    sms: {
      message: smsMessage,
    },
    channel: {
      ...channel,
      report: channelReport,
    },
    email: {
      message: emailMessage,
      send: emailSend,
      dns: emailDns,
    },
    automation: {
      flow: automationFlow,
      campaignTree: automationCampaignTree,
    },
    whatsapp: {
      config: configuration,
      message: whatsappMessage,
    },
    report: marketingReport,
  },
};
